// extracted by mini-css-extract-plugin
export default {"option":"_f4019541","optionBackdrop":"_4a879d23","optionHighlight":"_4f153cf1","optionSelected":"_c108a468"};